import { createSelector } from "@reduxjs/toolkit";

import { DetailsTableDataTypeEnum, MainTableDataTypeEnum } from "@ds/modules/table-data/utils/model";

import { type RootState } from "@ds/store/bootstrap";
import { selectorsOutputEntitiesByIds } from "@ds/store/global-selectors";

import { getAggregatedModel } from "@ds/utils/entities";
import { LoadStatus } from "@ds/utils/reducer";

import { AssetsRemoteOperation, entitySelectors } from "../slice";

export const selectBaseState = (state: RootState) => state.assets.assets;
const selectLoadStatus = (state: RootState, operation = AssetsRemoteOperation.CRUD) =>
  selectBaseState(state).loadStatusMap[operation];

export const selectAssetsIsLoading = (state: RootState, operation = AssetsRemoteOperation.CRUD) =>
  selectLoadStatus(state, operation) === LoadStatus.Loading;

export const selectAssetsIsSucceeded = (state: RootState, operation = AssetsRemoteOperation.CRUD) =>
  selectLoadStatus(state, operation) === LoadStatus.Succeeded;

export const selectTableAssetIds = (
  state: RootState,
  tableType: MainTableDataTypeEnum | DetailsTableDataTypeEnum = MainTableDataTypeEnum.AssetVideos,
) => selectBaseState(state).tableIds[tableType];

const selectSelectedAssetIds = (
  state: RootState,
  tableType: MainTableDataTypeEnum | DetailsTableDataTypeEnum = MainTableDataTypeEnum.AssetVideos,
) => selectBaseState(state).selectedIds[tableType];

export const selectAssetById = (state: RootState, id: number) =>
  entitySelectors.selectById(selectBaseState(state), id) as Asset;

export const selectTableAssets = createSelector(
  selectBaseState,
  selectTableAssetIds,
  selectorsOutputEntitiesByIds(() => entitySelectors),
);

export const selectSelectedAssets = createSelector(
  selectBaseState,
  selectSelectedAssetIds,
  selectorsOutputEntitiesByIds(() => entitySelectors),
);

export const selectAggregatedAssetForSelectedEntities = createSelector(selectSelectedAssets, selectedAssets =>
  getAggregatedModel(selectedAssets),
);
